/**
 * 各系统（platform）登录互斥：切换为不同 platform 时须重新登录。
 * 不写死任何平台名，仅比较 localStorage 中的 platform 与即将写入的目标 platform（大小写不敏感）。
 */
import { safeGetStorageItem, safeLocalStorage, safeRemoveStorageItem, safeSessionStorage, safeSetStorageItem } from '@/utils/safeStorage'

var OPEN_LOGIN_FLAG = 'otgame_openLoginAfterPlatformSwitch'

function equalsPlatformId(a, b) {
  return (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase()
}

/**
 * 是否视为「跨系统切换」：前后 platform 均已知且不相同。
 */
export function shouldRequireReloginOnPlatformChange(prevPlatform, nextPlatform) {
  var prev = (prevPlatform || '').trim()
  var next = (nextPlatform || '').trim()
  if (!prev || !next) {
    return false
  }
  return !equalsPlatformId(prev, next)
}

/**
 * 若应重登且存在 token：只清除未支付暂存并返回重登标记。
 * token 必须由后端明确 need_login 或 logout proof 确认后再清理。
 */
export function markReloginRequiredOnPlatformChange(prevPlatform, nextPlatform) {
  if (!shouldRequireReloginOnPlatformChange(prevPlatform, nextPlatform)) {
    return false
  }
  if (!safeGetStorageItem(safeLocalStorage(), 'token')) {
    return false
  }
  safeRemoveStorageItem(safeSessionStorage(), 'payOrderData')
  return true
}

export function clearTokenIfReloginRequired(prevPlatform, nextPlatform) {
  return markReloginRequiredOnPlatformChange(prevPlatform, nextPlatform)
}

export function setOpenLoginAfterReloadFlag() {
  safeSetStorageItem(safeSessionStorage(), OPEN_LOGIN_FLAG, '1')
}

export function consumeOpenLoginAfterPlatformSwitch() {
  const storage = safeSessionStorage()
  if (safeGetStorageItem(storage, OPEN_LOGIN_FLAG) === '1') {
    safeRemoveStorageItem(storage, OPEN_LOGIN_FLAG)
    return true
  }
  return false
}

export function logoutIfReloginRequiredWithToken(prevPlatform, nextPlatform) {
  var did = markReloginRequiredOnPlatformChange(prevPlatform, nextPlatform)
  if (did) {
    setOpenLoginAfterReloadFlag()
  }
  return did
}
